import { SCAVENGER_COLLECTION } from '../firebase/constants';
import useFirebaseQuery from '../firebase/useFirebaseQuery';
import { Scavenger } from './types';

const useScavenger = (): Scavenger => {
  const data = useFirebaseQuery(SCAVENGER_COLLECTION);

  if (!data) {
    return { id: '', currentStep: 'Intro' };
  }

  const docs = data.map((doc) => doc.data());
  return docs[0];
};

export default useScavenger;
